import { render } from "./LoginErrorModal.vue?vue&type=template&id=13b5df66&scoped=true&ts=true"
import script from "./LoginErrorModal.vue?vue&type=script&lang=ts"
export * from "./LoginErrorModal.vue?vue&type=script&lang=ts"

import "./LoginErrorModal.vue?vue&type=style&index=0&id=13b5df66&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b5df66"]])

export default __exports__